import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

// Assets
import { TravelRuleIcon } from 'assets/images/Icons'

// Store
import { actions } from 'core/store'

// Hooks
import { useLogout } from 'core/hooks/api'

// Styled Elements
import {
  AppSidebarDrawerWrapper,
  AppSidebarList,
  AppSidebarListItem,
  AppSidebarListIcon,
  AppSidebarListLink,
} from './AppSidebarDrawer.elements'

// Views
import { Drawer } from 'views/components'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions

function AppSidebarDrawer(props) {
  // Destructure
  const { ui, actions } = props

  // Store State
  const { isAppSidebarDrawerOpen } = ui

  // Store Actions
  const { closeAppSidebarDrawer } = actions

  // Hooks
  const { logoutUser } = useLogout()

  // Functions
  const handleCloseDrawer = () => {
    closeAppSidebarDrawer()
  }

  const handleClickSidebarNav = () => {
    closeAppSidebarDrawer()
  }

  const handleClickLogout = () => {
    logoutUser()
  }

  return (
    <Drawer open={isAppSidebarDrawerOpen} anchor="right" onClose={handleCloseDrawer}>
      <AppSidebarDrawerWrapper>
        <AppSidebarList>
          <AppSidebarListItem>
            <AppSidebarListLink to="/travelrule" onClick={handleClickSidebarNav}>
              <AppSidebarListIcon>
                <TravelRuleIcon size={25} />
              </AppSidebarListIcon>
              Travel Rule
            </AppSidebarListLink>
          </AppSidebarListItem>
        </AppSidebarList>
      </AppSidebarDrawerWrapper>
    </Drawer>
  )
}

// Default Props
AppSidebarDrawer.defaultProps = {
  ui: {},
  actions: {},
}

// Proptypes Validation
AppSidebarDrawer.propTypes = {
  ui: PropTypes.shape({ isAppSidebarDrawerOpen: PropTypes.bool }),
  actions: PropTypes.shape({ closeAppSidebarDrawer: PropTypes.func }),
}

export default connect(mapStateToProps, mapDispatchToProps)(AppSidebarDrawer)
